import React from 'react';
import api from '../../../api/apiClient';
import EventCalendarView from '../../../common/components/calendar/EventCalendarView';

const AdminEventCalendarPage = () => (
  <EventCalendarView
    title="Event Calendar"
    description="Platform-wide VILT sessions, live meetings, and assessment due dates."
    emptyMessage="Platform VILT, meetings, and assessment due dates will appear here."
    vltPath="/admin/vlt"
    assessmentMode="admin"
    loadEvents={async ({ start, end }) => {
      const response = await api.calendar.getAdminEvents({ start, end });
      return response.data?.data || [];
    }}
  />
);

export default AdminEventCalendarPage;
